import { EditorState, Plugin, PluginKey } from "prosemirror-state";
import { EditorView } from "prosemirror-view";

import { Extension } from "~/lib/prose/extension";
import type { AssignableDropdownMenuSections } from "~/notes/AssignableDropdown";

const key = new PluginKey<boolean>();

/**
 * Check if block actions should be displayed.
 */
export function blockActionsEnabled(state: EditorState): boolean {
	return key.getState(state) ?? false;
}

export function getBlockActionsPlugin(view: EditorView): BlockActions | undefined {
	return view.extensions.get("blockActions");
}

const plugin = new Plugin<boolean>({
	key,
	state: {
		init() {
			return true;
		},
		apply() {
			return true;
		},
	},
});

type BlockActionPluginOptions = {
	postProsessMenuSections?: (
		close: () => void,
		existingMenuSections: (c: () => void) => AssignableDropdownMenuSections,
	) => AssignableDropdownMenuSections;
	forceDesktopDropdown?: boolean;
};

/**
 * Adding this extension to the editor enables block actions.
 */
export class BlockActions extends Extension {
	name = "blockActions";
	options: BlockActionPluginOptions;
	constructor(options: BlockActionPluginOptions = {}) {
		super(options);
		this.options = options;
	}

	get plugins() {
		return [plugin];
	}
}
